<script setup lang="ts">
import type { GetToolDetailsQuery } from './ToolDetails.generated'

import DOMPurify from 'dompurify'
import BaseCarousel from '~/components/BaseCarousel.vue'

defineProps<{
  tool: GetToolDetailsQuery['tool']
}>()
</script>

<template>
  <div>
    <p
      class="tw:mb-6 tw:mt-0"
      v-html="DOMPurify.sanitize(tool?.description ?? '')"
    />

    <template v-if="tool">
      <template v-if="tool.images.length && tool.images.length > 1">
        <BaseCarousel class="tw:max-w-2xl">
          <template v-for="(img, i) in tool.images" #[`slide-${i}`] :key="i">
            <img :key="i" :src="img.url" class="tw:w-full tw:rounded-xl">
          </template>
        </BaseCarousel>
      </template>
      <template v-else-if="tool.images.length">
        <img
          :src="tool.images[0].url"
          class="tw:w-full tw:max-w-2xl tw:rounded-xl"
        >
      </template>
    </template>
  </div>
</template>
